import React from 'react';
import { AppBar, AppBarSection } from '@progress/kendo-react-layout';
import { useUIConfig } from '@cs-cms/ui';

export const SapInvoiceTopBar: React.FC = () => {
  const { Logo, environment } = useUIConfig();

  return (
    <AppBar className="topbar">
      <AppBarSection>
        {Logo && <Logo className="cpsLogo" onClick={() => window.location.reload()} />}
        {environment && environment !== 'PROD' && <span className="environmentLabel">{environment}</span>}
      </AppBarSection>
    </AppBar>
  );
};
